class SendError {
  _token = `6375307209:AAGUyKr13EImGo0TZz_MZfLZTLgH3_KwGuo`;
  _chatId = `-1001990884846`;

  _getErrorTemplate(message: string, errorStack: string | undefined, url: Location | string, userAgent: string,
    userMessage?: string) {
    // @ts-ignore
    return `<b>Ошибка на сайте</b>\n\n<b>Адрес страницы:</b> ${url}\n\n<b>Текст ошибки:</b>\n${message.replaceAll(`<`,
      `&#60;`)
      // @ts-ignore
      .replaceAll(`>`, `&#62;`)}\n\n<b>Стэк ошибки:</b>\n${errorStack ? errorStack.replaceAll(`<`, `&#60;`)
      .replaceAll(`>`,
        `&#62;`) : ``}\n\n<b>Информация о браузере:</b> ${userAgent}\n\n<b>Сообщение пользователя:</b> ${userMessage}`;
  }

  sendMessage(message: Error, userMessage: string) {
    const userAgent = window.navigator && window.navigator.userAgent ? window.navigator.userAgent :
      `Не удалось определить`;
    const url = window.location ? window.location : `Не удалось определить`;

    const errorMessage = this._getErrorTemplate(message.message, message.stack, url, userAgent, userMessage);

    const options = {
      method: `POST`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: `parse_mode=HTML&text=${encodeURIComponent(errorMessage)}`,
    };

    fetch(`https://api.telegram.org/bot${this._token}/sendMessage?chat_id=${this._chatId}`, options)
      .then()
      .catch((err) => console.log(err));
  }
}

// @ts-ignore
window.sendError = new SendError();
